
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M33.727 7.545H37a3.273 3.273 0 013.273 3.273v13.91A3.273 3.273 0 0137 28h-3.273v6.545L23.91 28h-3.273","stroke":"#111","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30.455 1H4.273A3.273 3.273 0 001 4.273v13.909c0 .707.36 1.707.942 2.297a3.263 3.263 0 002.33.976h6.546v8.181l11.455-8.181h8.182a3.273 3.273 0 003.272-3.273V4.272A3.273 3.273 0 0030.455 1z","stroke":"#111","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{staticClass:"word",attrs:{"d":"M7.806 15.371V11.62h3.67v-1.342h-3.67V7.879h4.059V6.537h-5.66v8.834h1.6zm5.403 0l.729-2.178h3.321l.734 2.178H19.7l-3.115-8.834h-1.975l-3.11 8.834h1.708zm3.619-3.463h-2.459l1.195-3.56h.069l1.195 3.56zm11.166 4.223l-1.225-1.57c.888-.777 1.436-2.006 1.436-3.607 0-2.855-1.742-4.538-4.059-4.538-2.32 0-4.06 1.683-4.06 4.538 0 2.852 1.74 4.538 4.06 4.538.56 0 1.087-.099 1.566-.289l.729.928h1.553zm-3.848-2.075c-1.436 0-2.45-1.092-2.45-3.102s1.014-3.101 2.45-3.101c1.44 0 2.45 1.091 2.45 3.101 0 1.087-.293 1.903-.793 2.425l-.751-.975h-1.45l1.195 1.57a2.473 2.473 0 01-.65.082z","fill":"#000","fill-rule":"nonzero"}})])])
          )
        }
      }
    